import { useEffect, useState } from "react";

export const useAnimatedMount = (show, duration = 1000) => {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setMounted(true);
      const enterTimeout = setTimeout(() => {
        setVisible(true);
      }, 10);

      return () => clearTimeout(enterTimeout);
    } else {
      setVisible(false);
      const exitTimeout = setTimeout(() => {
        setMounted(false);
      }, duration);

      return () => clearTimeout(exitTimeout);
    }
  }, [show, duration]);

  return { mounted, visible };
};